import { AppManager } from "..";
import { QueryResultCallback } from "../../models/Callback/Callback";
import { IMasterlistRecordAttrs } from "../../models/ServicesFees/MasterlistRecord";
import { ServiceFeeStoreActions } from "../../redux/services/servicesfees/actions";
import { APIManager } from "../APIManager";

export class MasterlistManager {
    async apiFetchAllRecords(cb: QueryResultCallback<IMasterlistRecordAttrs[]>) {
        try {
            ServiceFeeStoreActions.loadingRecords(true);
            const resp = await APIManager.get(APIManager.MASTERLIST.MASTERLIST_RECORDS_API);
            ServiceFeeStoreActions.saveRecords(resp.data);
            ServiceFeeStoreActions.setRecordsLoaded(true);
            cb(null, resp.data);
        } catch (err) {
            cb(`${err}`);
        } finally {
            ServiceFeeStoreActions.loadingRecords(false);
        }
    }

    async apiAddNewRecords(newRecords: IMasterlistRecordAttrs[], cb: QueryResultCallback<IMasterlistRecordAttrs[]>) {
        try {
            const resp = await APIManager.post(APIManager.MASTERLIST.MASTERLIST_RECORDS_API, newRecords);
            this.updateOrAddRecords(resp.data);
            cb(null, resp.data);
        } catch (err) {
            cb(`${err}`);
        }
    }

    async apiUpdateRecord(recordId: string, recordData: Partial<IMasterlistRecordAttrs>, cb: QueryResultCallback<IMasterlistRecordAttrs>) {
        try {
            const resp = await APIManager.put(APIManager.MASTERLIST.MASTERLIST_SINGLE_RECORD_API(recordId), recordData);
            ServiceFeeStoreActions.addOrUpdateToRecords(resp.data);
            cb(null, resp.data);
        } catch (err) {
            cb(`${err}`);
        }
    }

    async apiDeleteRecord(recordId: string, cb: QueryResultCallback<IMasterlistRecordAttrs>) {
        try {
            const resp = await APIManager.delete(APIManager.MASTERLIST.MASTERLIST_SINGLE_RECORD_API(recordId));
            ServiceFeeStoreActions.removeRecord(recordId);
            cb(null, resp.data);
        } catch (err) {
            cb(`${err}`);
        }
    }

    updateOrAddRecords(recordData: IMasterlistRecordAttrs[], areNewRecords = false) {
        console.log("RECORD DATA IS ", recordData);
        const allRecords = ServiceFeeStoreActions.getRecords();
        for (let i = 0; i < allRecords.length; i++) {
            const record = allRecords[i];
            const updatedRecordInd = recordData.findIndex((t) => t._id === record._id);
            if (updatedRecordInd >= 0) {
                allRecords[i] = recordData[updatedRecordInd];
                recordData.splice(updatedRecordInd, 1);
            } else if (areNewRecords) {
                allRecords[i].isNewRecord = false;
            }
            if (!recordData.length && !areNewRecords) break;
        }
        AppManager.servicefee.provider.apiFetchAllProviderAdviserRefs(() => {});
        AppManager.servicefee.provider.apiFetchAllProviders(() => {});
        ServiceFeeStoreActions.saveRecords([...recordData, ...allRecords]);
    }

    removeRecord(recordData: IMasterlistRecordAttrs) {
        const allRecords = ServiceFeeStoreActions.getRecords().filter((t) => t._id !== recordData._id);
        ServiceFeeStoreActions.saveRecords(allRecords);
    }
}
